import styled from '@emotion/styled'
import { LoadingSpinner } from 'components/core-v2/atoms/loading-spinner'
import {
  TablePagination,
  TablePaginationParams
} from 'components/core-v2/molecules/table-pagination'
import { useState } from 'react'

import { Space, Typography } from '../../../components/core-v2'
import Icon from '../../../components/core-v2/atoms/Icon'
import LinkIcon from '../../../components/core-v2/molecules/linkIcon'
import AssetsView from '../templates/assets-view'
import { AssetFull } from '../types'
import { RenameFundManagerModal } from './rename-fund-manager-modal'

export type AssetsPanelProps = {
  assets: AssetFull[]
  canUserSave: boolean
  isLoading: boolean
  numTotalAssets: number
  onFundManagerRenamed?: () => void
  onPaginationChange: (updatedPagination: TablePaginationParams) => void
  onSearch: (searchTerm: string) => void
  onSelectAsset?: (assetId: string) => void
  onSelectNewAsset: () => void
  pagination: TablePaginationParams
  selectedAsset?: AssetFull
}

const StyledInput = styled.input`
  width: 100%;
  padding: 12px;
  margin: 0;
  border: none;
  background: var(--White95);
  font-size: 15px;
  outline: none;
  font-weight: normal;
  color: var(--Graphite);
`

const StyledList = styled.div`
  border-top: solid 1px var(--White90);
  height: calc(100vh - 290px);
  overflow-y: auto;
  position: relative;
`

const LoadingPanel = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20vh;
  padding-bottom: 16px;
  position: absolute;
  width: 100%;
`

export const AssetsPanel = ({
  assets,
  canUserSave,
  isLoading,
  numTotalAssets,
  onFundManagerRenamed,
  onPaginationChange,
  onSearch,
  onSelectAsset,
  onSelectNewAsset,
  pagination,
  selectedAsset
}: AssetsPanelProps) => {
  const [isRenameFundManagerOpen, setIsRenameFundManagerOpen] = useState(false)

  return (
    <Space isflex flexDirection="column">
      <Space mt={6}>
        <StyledInput type="text" onChange={e => onSearch(e.target.value)} />
      </Space>
      <Space isflex justifyContent="space-between" py={6}>
        <Typography fontSize="15px" fontWeight="800" letterSpacing="0px" variant="b3">
          {numTotalAssets} assets found
        </Typography>
        {canUserSave && (
          <Space isflex>
            <LinkIcon
              disabled={false}
              icon={<Icon name="users" size="default" />}
              iconPosition="left"
              text="Rename fund manager"
              onClick={() => setIsRenameFundManagerOpen(true)}
            />
            <LinkIcon
              disabled={false}
              icon={<Icon name="circleAdd" size="default" />}
              iconPosition="left"
              text="Add a new asset"
              onClick={() => onSelectNewAsset()}
            />
          </Space>
        )}
      </Space>
      <Space my={4}>
        <TablePagination pagination={pagination} onChange={onPaginationChange} />
      </Space>
      <StyledList>
        {isLoading && (
          <LoadingPanel>
            <LoadingSpinner />
          </LoadingPanel>
        )}
        <AssetsView assets={assets} selectedAsset={selectedAsset} onSelectAsset={onSelectAsset} />
      </StyledList>
      {isRenameFundManagerOpen && (
        <RenameFundManagerModal
          onClose={() => setIsRenameFundManagerOpen(false)}
          onRenamed={onFundManagerRenamed}
        />
      )}
    </Space>
  )
}
